import React, { useState } from "react";
import { List, ListItem, ListItemButton, ListItemIcon } from "@mui/material";
import {
  FormatShapesOutlined as PolyIcon,
  Print as PrintIcon,
} from "@mui/icons-material";

import { COMMON_JS } from "common/scripts";

const PolyFilters = (props: any) => {
  const { onPrintMap, resetFilteredList, showTrips } = props;
  const [showPoly, setShowPoly] = useState(false);

  const createPolygon = () => {
    if (showPoly) {
      resetFilteredList();
      setShowPoly(!showPoly);
    } else {
      setShowPoly(!showPoly);
      COMMON_JS.drawPolygon();
    }
  };

  const editPolygon = () => {
    let e = document.createEvent("Event");
    e.initEvent("click", true, true);
    let cb = document.getElementsByClassName("leaflet-draw-edit-edit");
    console.log("Zone editPolygon");
    if (cb) {
      return !cb[0].dispatchEvent(e);
    }
  };

  const closeDrawZone = () => {
    console.log("closeDrawZone: ");
    let e = document.createEvent("Event");
    e.initEvent("click", true, true);
    let cb = document.querySelector(
      'ul.leaflet-draw-actions li>a[title="Cancel drawing"]'
    );
    if (cb) {
      cb.dispatchEvent(e);
    }
    cb = document.querySelector(
      'ul.leaflet-draw-actions.leaflet-draw-actions-top>li>a[title="Cancel editing, discards all changes"]'
    );
    if (cb) {
      cb.dispatchEvent(e);
    }
    clearLayers();
  };

  const clearLayers = () => {
    let e = document.createEvent("Event");
    e.initEvent("click", true, true);
    let cb = document.querySelector(".leaflet-draw-edit-remove");
    if (cb) {
      cb.dispatchEvent(e);
    }
    let e2 = document.createEvent("Event");
    e2.initEvent("click", true, true);
    cb = document.querySelector(
      "ul.leaflet-draw-actions.leaflet-draw-actions-bottom li:last-child>a"
    );
    if (cb) {
      cb.dispatchEvent(e2);
    }
    // this.props.setZoneEdit({
    //   zoneVertices: [],
    // });
  };

  console.log("showPoly: ", showPoly);

  return (
    <div className={showTrips ? "mapTripsPolyControl" : "mapPolyControls"}>
      <List>
        <ListItem
          disablePadding
          className={showPoly ? "active" : ""}
          onClick={createPolygon}
        >
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <PolyIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        {/* <ListItem disablePadding onClick={onPrintMap} className={"active"}>
          <ListItemButton className="listItemBtn">
            <ListItemIcon className="listIcon">
              <PrintIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem> */}
      </List>
      {/* <UiDialog
        title={"Search"}
        open={showPoly}
        draggable={true}
        size={"sm"}
        onClose={() => {
          setShowPoly(false);
        }}
      >
        <TxtBox id={"polyName"} placeholder={"Name"} />
      </UiDialog> */}
    </div>
  );
};

export default PolyFilters;
